export default __webpack_public_path__ + "static/asistencia_tecnica-084d37877f0c5e0d87fae9e25b2e606a.png";